/* eslint-disable */
import { Mesh } from 'three';

import { MinimalistDoor } from './Base';

import { ashwoodMat, foressoMat, getRGBFromRAL, metalMat } from '../Materials';

const mediaBucketUrl = process.env.NEXT_PUBLIC_MEDIA_BUCKET_URL;

export class ForessoDoor extends MinimalistDoor {
  constructor(...args) {
    super(...args);

    const attributes = args[0];

    // load the key resources
    this.resourceManager.loadResources(['hiddenSystem'], () => {
      this.update(attributes);
      this.renderFunc();
    });

    // Define the materials
    this.materialDefinitions = {
      handle: { ...foressoMat },
      metal: { ...metalMat },
      wood: { ...ashwoodMat },
    };

    this.initMaterials();
    this.update(attributes);
  }

  updateModelParameters(attributes) {
    // Set the parameters
    this.parameters.style = attributes['door-style']
      ? attributes['door-style']
      : 'round';

    // Set the new door color
    const doorColor = attributes['door-color']
      ? attributes['door-color']
      : attributes['door-color-ash']
      ? attributes['door-color-ash']
      : 'ashwood_natural';

    // Set the handle color
    const handleColor = attributes['handle-color']
      ? attributes['handle-color']
      : 'light_ral9005';

    const handleParams = handleColor.split('_');
    const texture = handleParams[0];
    const color = getRGBFromRAL(handleParams[1]);

    this.materialDefinitions.wood.map = `${mediaBucketUrl}textures/${doorColor}.jpg`;
    // this.materialDefinitions.wood.color = 0x0000FF;
    this.materialDefinitions.metal.color = color;
    this.materialDefinitions.handle.map = `${mediaBucketUrl}textures/foresso_${texture}.jpg`;

    // Update the material
    this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
    this.updateMaterial(this.materials.handle, this.materialDefinitions.handle);
    this.updateMaterial(this.materials.wood, this.materialDefinitions.wood);
  }

  buildModel() {
    const SideBar = this.buildSideBarGeometry();
    const Body = this.buildBodyGeometry();
    const Handle = this.buildHandleGeometry();
    const Plate = this.buildPlateGeometry();
    // const Hanger = this.buildHangerGeometry();

    SideBar.forEach((geometry) => {
      this.group.add(
        new Mesh(this.updateGeometry(geometry, 90), this.materials.wood)
      );
    });
    Body.forEach((geometry) => {
      this.group.add(
        new Mesh(this.updateGeometry(geometry, 0, 2048, 1), this.materials.wood)
      );
    });
    Handle.forEach((geometry) => {
      this.group.add(
        new Mesh(this.updateGeometry(geometry), this.materials.handle)
      );
    });
    Plate.forEach((geometry) => {
      this.group.add(
        new Mesh(this.updateGeometry(geometry), this.materials.metal)
      );
    });
    /* Hanger.forEach((geometry) => {
      this.group.add(
        new Mesh(
          geometry,
          this.materials.metal
        )
      );
    });*/

    this.group.children.forEach((z) => {
      z.castShadow = true;
      z.receiveShadow = true;
    });

    this.group.position.y = -35;
  }
}
